import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { hasAnyRole, homePathFor } from '../auth/roles';
import { paths } from './paths';

/**
 * Route guards, used as layout routes so one wrapper protects a whole branch:
 *   <Route element={<RequireAuth />}> …signed-in pages… </Route>
 *   <Route element={<RequireRole roles={[ROLES.ADMIN]} />}> …admin pages… </Route>
 * The page the visitor wanted is passed to the login page in `state.from`, so login can send
 * them straight back to it.
 */
export function RequireAuth() {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  if (!isLoggedIn) return <Navigate to={paths.login} replace state={{ from: location }} />;
  return <Outlet />;
}

export function RequireRole({ roles }) {
  const { user, isLoggedIn } = useAuth();
  const location = useLocation();
  if (!isLoggedIn) return <Navigate to={paths.login} replace state={{ from: location }} />;
  // Signed in but the wrong role: send them to the place their role belongs, never back here.
  if (!hasAnyRole(user, roles)) return <Navigate to={homePathFor(user)} replace />;
  return <Outlet />;
}
